"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Container, Link as MuiLink, Typography } from "@mui/material";
import Link from "next/link";
import React from "react";
import { PrivacyCookieInventoryTable } from "#/features/privacy/ui/PrivacyCookieInventoryTable";
import { useI18nContext } from "#/shared/hooks";
import { MainLayout } from "#/shared/ui/templates/MainLayout";
const PrivacySection: React.FC<{
  title: string;
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(6);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mt: 4
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Typography variant="h5" component="h2" gutterBottom={true}>{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <Box component="section" sx={t1}>{t2}{children}</Box>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const PrivacyParagraph: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mb: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Typography variant="body1" color="text.secondary" sx={t1}>{children}</Typography>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};

/** Privacy policy content. Shared by Pages `/privacy` and App Router pilot. */
export const PrivacyPageView: React.FC = () => {
  const $ = _c(188);
  const {
    LL
  } = useI18nContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      py: 4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== LL) {
    t1 = LL.PRIVACY_PAGE_TITLE();
    $[1] = LL;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Typography variant="h4" component="h1" gutterBottom={true}>{t1}</Typography>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== LL) {
    t3 = LL.PRIVACY_INTRO();
    $[5] = LL;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <PrivacyParagraph>{t3}</PrivacyParagraph>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== LL) {
    t5 = LL.PRIVACY_LAST_UPDATED();
    $[9] = LL;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <PrivacyParagraph>{t5}</PrivacyParagraph>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== LL) {
    t7 = LL.PRIVACY_CONTROLLER_TITLE();
    $[13] = LL;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== LL) {
    t8 = LL.PRIVACY_CONTROLLER_BODY();
    $[15] = LL;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <PrivacyParagraph>{t8}</PrivacyParagraph>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== LL) {
    t10 = LL.PRIVACY_CONTACT_INTRO();
    $[19] = LL;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== LL) {
    t11 = LL.PRIVACY_CONTACT_EMAIL();
    $[21] = LL;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = `mailto:${t11}`;
  let t13;
  if ($[23] !== LL) {
    t13 = LL.PRIVACY_CONTACT_EMAIL();
    $[23] = LL;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12 || $[26] !== t13) {
    t14 = <MuiLink href={t12}>{t13}</MuiLink>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14) {
    t15 = <PrivacyParagraph>{t10}{" "}{t14}.</PrivacyParagraph>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15 || $[32] !== t7 || $[33] !== t9) {
    t16 = <PrivacySection title={t7}>{t9}{t15}</PrivacySection>;
    $[31] = t15;
    $[32] = t7;
    $[33] = t9;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== LL) {
    t17 = LL.PRIVACY_DATA_COLLECTED_TITLE();
    $[35] = LL;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== LL) {
    t18 = LL.PRIVACY_DATA_COLLECTED_BODY();
    $[37] = LL;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = <PrivacyParagraph>{t18}</PrivacyParagraph>;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t17 || $[42] !== t19) {
    t20 = <PrivacySection title={t17}>{t19}</PrivacySection>;
    $[41] = t17;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== LL) {
    t21 = LL.PRIVACY_LEGAL_BASES_TITLE();
    $[44] = LL;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== LL) {
    t22 = LL.PRIVACY_LEGAL_BASES_BODY();
    $[46] = LL;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t22) {
    t23 = <PrivacyParagraph>{t22}</PrivacyParagraph>;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t21 || $[51] !== t23) {
    t24 = <PrivacySection title={t21}>{t23}</PrivacySection>;
    $[50] = t21;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  let t25;
  if ($[53] !== LL) {
    t25 = LL.PRIVACY_RETENTION_TITLE();
    $[53] = LL;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== LL) {
    t26 = LL.PRIVACY_RETENTION_BODY();
    $[55] = LL;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t26) {
    t27 = <PrivacyParagraph>{t26}</PrivacyParagraph>;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t25 || $[60] !== t27) {
    t28 = <PrivacySection title={t25}>{t27}</PrivacySection>;
    $[59] = t25;
    $[60] = t27;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== LL) {
    t29 = LL.PRIVACY_RIGHTS_TITLE();
    $[62] = LL;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== LL) {
    t30 = LL.PRIVACY_RIGHTS_BODY();
    $[64] = LL;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== t30) {
    t31 = <PrivacyParagraph>{t30}</PrivacyParagraph>;
    $[66] = t30;
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== LL) {
    t32 = LL.PRIVACY_WITHDRAW_CONSENT_BODY();
    $[68] = LL;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== t32) {
    t33 = <PrivacyParagraph>{t32}</PrivacyParagraph>;
    $[70] = t32;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== t29 || $[73] !== t31 || $[74] !== t33) {
    t34 = <PrivacySection title={t29}>{t31}{t33}</PrivacySection>;
    $[72] = t29;
    $[73] = t31;
    $[74] = t33;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== LL) {
    t35 = LL.PRIVACY_SUBPROCESSORS_TITLE();
    $[76] = LL;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] !== LL) {
    t36 = LL.PRIVACY_SUBPROCESSORS_BODY();
    $[78] = LL;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== t36) {
    t37 = <PrivacyParagraph>{t36}</PrivacyParagraph>;
    $[80] = t36;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] !== t35 || $[83] !== t37) {
    t38 = <PrivacySection title={t35}>{t37}</PrivacySection>;
    $[82] = t35;
    $[83] = t37;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== LL) {
    t39 = LL.PRIVACY_TRANSFERS_TITLE();
    $[85] = LL;
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  let t40;
  if ($[87] !== LL) {
    t40 = LL.PRIVACY_TRANSFERS_BODY();
    $[87] = LL;
    $[88] = t40;
  } else {
    t40 = $[88];
  }
  let t41;
  if ($[89] !== t40) {
    t41 = <PrivacyParagraph>{t40}</PrivacyParagraph>;
    $[89] = t40;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== t39 || $[92] !== t41) {
    t42 = <PrivacySection title={t39}>{t41}</PrivacySection>;
    $[91] = t39;
    $[92] = t41;
    $[93] = t42;
  } else {
    t42 = $[93];
  }
  let t43;
  if ($[94] !== LL) {
    t43 = LL.PRIVACY_COOKIES_SECTION_TITLE();
    $[94] = LL;
    $[95] = t43;
  } else {
    t43 = $[95];
  }
  let t44;
  if ($[96] !== LL) {
    t44 = LL.PRIVACY_COOKIES_OVERVIEW_BODY();
    $[96] = LL;
    $[97] = t44;
  } else {
    t44 = $[97];
  }
  let t45;
  if ($[98] !== t44) {
    t45 = <PrivacyParagraph>{t44}</PrivacyParagraph>;
    $[98] = t44;
    $[99] = t45;
  } else {
    t45 = $[99];
  }
  let t46;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = {
      mt: 3,
      mb: 1
    };
    $[100] = t46;
  } else {
    t46 = $[100];
  }
  let t47;
  if ($[101] !== LL) {
    t47 = LL.PRIVACY_COOKIES_ESSENTIAL_TITLE();
    $[101] = LL;
    $[102] = t47;
  } else {
    t47 = $[102];
  }
  let t48;
  if ($[103] !== t47) {
    t48 = <Typography variant="h6" component="h3" sx={t46}>{t47}</Typography>;
    $[103] = t47;
    $[104] = t48;
  } else {
    t48 = $[104];
  }
  let t49;
  if ($[105] !== LL) {
    t49 = LL.PRIVACY_COOKIES_ESSENTIAL_BODY();
    $[105] = LL;
    $[106] = t49;
  } else {
    t49 = $[106];
  }
  let t50;
  if ($[107] !== t49) {
    t50 = <PrivacyParagraph>{t49}</PrivacyParagraph>;
    $[107] = t49;
    $[108] = t50;
  } else {
    t50 = $[108];
  }
  let t51;
  if ($[109] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      mt: 3,
      mb: 1
    };
    $[109] = t51;
  } else {
    t51 = $[109];
  }
  let t52;
  if ($[110] !== LL) {
    t52 = LL.PRIVACY_COOKIES_PREFERENCES_TITLE();
    $[110] = LL;
    $[111] = t52;
  } else {
    t52 = $[111];
  }
  let t53;
  if ($[112] !== t52) {
    t53 = <Typography variant="h6" component="h3" sx={t51}>{t52}</Typography>;
    $[112] = t52;
    $[113] = t53;
  } else {
    t53 = $[113];
  }
  let t54;
  if ($[114] !== LL) {
    t54 = LL.PRIVACY_COOKIES_PREFERENCES_BODY();
    $[114] = LL;
    $[115] = t54;
  } else {
    t54 = $[115];
  }
  let t55;
  if ($[116] !== t54) {
    t55 = <PrivacyParagraph>{t54}</PrivacyParagraph>;
    $[116] = t54;
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = {
      mt: 3,
      mb: 1
    };
    $[118] = t56;
  } else {
    t56 = $[118];
  }
  let t57;
  if ($[119] !== LL) {
    t57 = LL.PRIVACY_COOKIES_ANALYTICS_TITLE();
    $[119] = LL;
    $[120] = t57;
  } else {
    t57 = $[120];
  }
  let t58;
  if ($[121] !== t57) {
    t58 = <Typography variant="h6" component="h3" sx={t56}>{t57}</Typography>;
    $[121] = t57;
    $[122] = t58;
  } else {
    t58 = $[122];
  }
  let t59;
  if ($[123] !== LL) {
    t59 = LL.PRIVACY_COOKIES_ANALYTICS_BODY();
    $[123] = LL;
    $[124] = t59;
  } else {
    t59 = $[124];
  }
  let t60;
  if ($[125] !== t59) {
    t60 = <PrivacyParagraph>{t59}</PrivacyParagraph>;
    $[125] = t59;
    $[126] = t60;
  } else {
    t60 = $[126];
  }
  let t61;
  if ($[127] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = {
      mt: 3,
      mb: 1
    };
    $[127] = t61;
  } else {
    t61 = $[127];
  }
  let t62;
  if ($[128] !== LL) {
    t62 = LL.PRIVACY_COOKIE_TABLE_TITLE();
    $[128] = LL;
    $[129] = t62;
  } else {
    t62 = $[129];
  }
  let t63;
  if ($[130] !== t62) {
    t63 = <Typography variant="h6" component="h3" sx={t61}>{t62}</Typography>;
    $[130] = t62;
    $[131] = t63;
  } else {
    t63 = $[131];
  }
  let t64;
  if ($[132] !== LL) {
    t64 = LL.PRIVACY_COOKIE_TABLE_INTRO();
    $[132] = LL;
    $[133] = t64;
  } else {
    t64 = $[133];
  }
  let t65;
  if ($[134] !== t64) {
    t65 = <PrivacyParagraph>{t64}</PrivacyParagraph>;
    $[134] = t64;
    $[135] = t65;
  } else {
    t65 = $[135];
  }
  let t66;
  if ($[136] !== LL) {
    t66 = <PrivacyCookieInventoryTable LL={LL} />;
    $[136] = LL;
    $[137] = t66;
  } else {
    t66 = $[137];
  }
  let t67;
  if ($[138] !== t43 || $[139] !== t45 || $[140] !== t48 || $[141] !== t50 || $[142] !== t53 || $[143] !== t55 || $[144] !== t58 || $[145] !== t60 || $[146] !== t63 || $[147] !== t65 || $[148] !== t66) {
    t67 = <PrivacySection title={t43}>{t45}{t48}{t50}{t53}{t55}{t58}{t60}{t63}{t65}{t66}</PrivacySection>;
    $[138] = t43;
    $[139] = t45;
    $[140] = t48;
    $[141] = t50;
    $[142] = t53;
    $[143] = t55;
    $[144] = t58;
    $[145] = t60;
    $[146] = t63;
    $[147] = t65;
    $[148] = t66;
    $[149] = t67;
  } else {
    t67 = $[149];
  }
  let t68;
  if ($[150] !== LL) {
    t68 = LL.PRIVACY_EXECUTION_TITLE();
    $[150] = LL;
    $[151] = t68;
  } else {
    t68 = $[151];
  }
  let t69;
  if ($[152] !== LL) {
    t69 = LL.PRIVACY_EXECUTION_BODY();
    $[152] = LL;
    $[153] = t69;
  } else {
    t69 = $[153];
  }
  let t70;
  if ($[154] !== t69) {
    t70 = <PrivacyParagraph>{t69}</PrivacyParagraph>;
    $[154] = t69;
    $[155] = t70;
  } else {
    t70 = $[155];
  }
  let t71;
  if ($[156] !== t68 || $[157] !== t70) {
    t71 = <PrivacySection title={t68}>{t70}</PrivacySection>;
    $[156] = t68;
    $[157] = t70;
    $[158] = t71;
  } else {
    t71 = $[158];
  }
  let t72;
  if ($[159] !== LL) {
    t72 = LL.PRIVACY_CCPA_TITLE();
    $[159] = LL;
    $[160] = t72;
  } else {
    t72 = $[160];
  }
  let t73;
  if ($[161] !== LL) {
    t73 = LL.PRIVACY_CCPA_BODY();
    $[161] = LL;
    $[162] = t73;
  } else {
    t73 = $[162];
  }
  let t74;
  if ($[163] !== t73) {
    t74 = <PrivacyParagraph>{t73}</PrivacyParagraph>;
    $[163] = t73;
    $[164] = t74;
  } else {
    t74 = $[164];
  }
  let t75;
  if ($[165] !== t72 || $[166] !== t74) {
    t75 = <PrivacySection title={t72}>{t74}</PrivacySection>;
    $[165] = t72;
    $[166] = t74;
    $[167] = t75;
  } else {
    t75 = $[167];
  }
  let t76;
  if ($[168] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = {
      mt: 4
    };
    $[168] = t76;
  } else {
    t76 = $[168];
  }
  let t77;
  if ($[169] !== LL) {
    t77 = LL.DASHBOARD();
    $[169] = LL;
    $[170] = t77;
  } else {
    t77 = $[170];
  }
  let t78;
  if ($[171] !== t77) {
    t78 = <Typography variant="body2" color="text.secondary" sx={t76}><MuiLink component={Link} href="/" underline="hover">{t77}</MuiLink></Typography>;
    $[171] = t77;
    $[172] = t78;
  } else {
    t78 = $[172];
  }
  let t79;
  if ($[173] !== t16 || $[174] !== t2 || $[175] !== t20 || $[176] !== t24 || $[177] !== t28 || $[178] !== t34 || $[179] !== t38 || $[180] !== t4 || $[181] !== t42 || $[182] !== t6 || $[183] !== t67 || $[184] !== t71 || $[185] !== t75 || $[186] !== t78) {
    t79 = <MainLayout><Container maxWidth="md" sx={t0}>{t2}{t4}{t6}{t16}{t20}{t24}{t28}{t34}{t38}{t42}{t67}{t71}{t75}{t78}</Container></MainLayout>;
    $[173] = t16;
    $[174] = t2;
    $[175] = t20;
    $[176] = t24;
    $[177] = t28;
    $[178] = t34;
    $[179] = t38;
    $[180] = t4;
    $[181] = t42;
    $[182] = t6;
    $[183] = t67;
    $[184] = t71;
    $[185] = t75;
    $[186] = t78;
    $[187] = t79;
  } else {
    t79 = $[187];
  }
  return t79;
};